import { GetServerSideProps } from 'next';

import { Unauthorized } from '@/components/tax-refund/common/view/ErrorView/Unauthorized';
import { createErrorPageLayout, parseTopNavButtonQuery } from '@/lib/utils/layout';

const UnauthorizedErrorPage = () => <Unauthorized />;

UnauthorizedErrorPage.getLayout = createErrorPageLayout({ isNoticeVisible: false });

export const getServerSideProps = (async ({ query }) => {
  return { props: parseTopNavButtonQuery(query) };
}) satisfies GetServerSideProps;

export default UnauthorizedErrorPage;
